module.exports = __webpack_public_path__ + "img/add_circle.6a4d5838.svg";